






































import {
  ref,
  useContext,
  useRoute,
  defineComponent,
  useFetch,
  computed,
  watch,
  onMounted,
} from '@nuxtjs/composition-api';
import axios from 'axios';
import ClientOnly from 'vue-client-only';
import { merge } from 'lodash-es';
import { useApi, useUiNotification, useConfig } from '~/composables';
import LoadWhenVisible from '~/components/utils/LoadWhenVisible.vue';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { getAxiosConfigs } from '~/utils/solepro/functions';
import useLoader from '~/composables/useLoader';
import { BUNDLE_TYPE_ID, META_PDP_SET_NAME } from '~/utils/constants/product';
import AddToCartWrapper from '~/components/solepro/ProductPage/AddToCartWrapper.vue';
import ProductOptions from '~/components/solepro/ProductPage/PurchaseOptions/ProductOptions.vue';
import { getIsBook } from '~/utils/solepro/products';
import { productView, productLinkTrack, productBuyCTATrack } from '~/helpers/trackings/24orepro/products';
import SingleCardPurchaseOptions from '~/components/solepro/ProductPage/PurchaseOptions/SingleCardPurchaseOptions.vue';
import OfflinePurchase from '~/components/solepro/ProductPage/OfflinePurchase.vue';
import HTMLContent from '~/components/solepro/HTMLContent.vue';
import OfflineBooksPurchase from '~/components/solepro/ProductPage/OfflineBooksPurchase.vue';
import { getOptionsBlock } from '~/utils/helpers/product';
import { GET_AI_CONFIG } from '~/modules/storeConfig/queries/getStoreCategoriesConfig.gql';
import useMeta from '~/composables/useMeta';
import { PropType } from 'vue';
import PlansBenchmark from '~/components/solepro/ProductPage/PlansBenchmark/PlansBenchmark.vue';
import { manageScroll } from '~/utils/helpers/functions';
import Teleport from 'vue2-teleport';
import AreaBottom from '~/components/solepro/ProductPage/AreaBottom.vue';
export default defineComponent({
  name: 'ProductPage',
  components: {
    LoadWhenVisible,
    AddToCartWrapper,
    ProductOptions,
    SingleCardPurchaseOptions,
    OfflinePurchase,
    OfflineBooksPurchase,
    HTMLContent,
    ClientOnly,
    PlansBenchmark,
    Teleport,
    AreaBottom
  },
  props: {
    node: {
      type: Object as PropType<ProductForProductPageType>,
      required: true
    },
  },
  setup(props) {
    const { node: content } = props as Readonly<{ [key: string]: any }>;

    const { send: sendNotification } = useUiNotification();
    const { setIsLoading, isLoading } = useLoader();
    const { app } = useContext();
    const { i18n } = app;
    const { query } = useApi();
    const { config } = useConfig();
    const product = ref<ProductForProductPageType | null>(null);
    const cardOptions = ref([]);
    const renderProductElements = ref(false)
    const isAiProduct = ref<Boolean>(false)
    const isMetaPDP = ref(false);
    const { setMeta, setCanAddMultipleSubProducts } = useMeta();
    const ProductInfoComponent = ref(null);
    const trackPageView = async (product) => {
      await productView(product);
      await productLinkTrack(product);
    };

    const trackProductCTA = async (product) => {
      await productBuyCTATrack(product)
    }

    const fetchProductData = async () => {
      setIsLoading(true);
      const { data: aiData } = await query(GET_AI_CONFIG);
      const AICategory = aiData['storeConfig'].sole_professionisti_ai_category;
      try {
        const skus = content.skus ? content.skus : content.children[0].skus
        renderProductElements.value = !(content.skus ? content: content.children[0]).cssClasses.includes('no-content')
        const { data } = await axios.get(`/sole-api/product/getProduct?sku=${skus[0]}`, { ...getAxiosConfigs(app, config) });

        let tmp: ProductForProductPageType = merge({}, data as ProductForProductPageType ?? null);
        /** Fetching additionalProducts for MetaPDP and merge inside productModel. */
        /** @TODO avoid promise all and make one call with "in" filter */
        let additionalProducts = data?.additionalSkus ? await Promise.all(
          (data?.additionalSkus ?? "").split(',').map(async (filter) => {
            const queryParams = new URLSearchParams({ urlKey: null, sku: filter }).toString();
            const { data: addictionalProductData } = await axios.get(`/sole-api/product/getProduct?${queryParams}`, { ...getAxiosConfigs(app, config) });
            return addictionalProductData

          })
        ) : [];
        tmp = merge(data as ProductForProductPageType, { additionalProducts });

        product.value = tmp;
        //isAiProduct.value = !!tmp.categories.find(el => el.id == AICategory)
        ProductInfoComponent.value = getIsBook(tmp) ? () => import('~/components/solepro/ProductPage/ProductInfoLibriECollane.vue') : () => import('~/components/solepro/ProductPage/ProductInfo.vue')

      } catch (e) {
        sendNotification({
          id: Symbol('product_not_found'),
          message: i18n.t('An error occurred retrieving this product') as string,
          type: 'danger',
          icon: 'cross',
          persist: true,
        });
        console.error(e);
      }
      setIsLoading(false);
    };

    useFetch(async () => {
      await fetchProductData();
      isMetaPDP.value = product.value.attributeSetName == META_PDP_SET_NAME;
      cardOptions.value = getOptionsBlock(product.value);
    });

    const isBook = computed(() => {
      return getIsBook(product.value)
    })

    /** END Added */
    const hasOnlyNotBuyable = computed(() => product.value.additionalProducts && product.value.additionalProducts.length > 0
      && product.value.additionalProducts.every(p => !p.buyable))
    watch(isMetaPDP, (newValue) => {
      setCanAddMultipleSubProducts(product.value.canAddMultipleSubproducts)
      setMeta(newValue, newValue ? product.value.additionalSkus.split(',') : [])
    })

    onMounted(()=>{
        trackPageView(product.value);

    })

    return {
      product,
      isMetaPDP,
      isLoading,
      isBook,
      trackProductCTA,
      cardOptions,
      hasOnlyNotBuyable,
      isAiProduct,
      ProductInfoComponent,
      renderProductElements
    };
  },
  methods: {
    async manageScroll(evt) {
      const $th = this as any; /** workaround for my dumb eslint */
      manageScroll(evt)
      await $th.trackProductCTA($th.product);
    }
  },
});
